import { errorMessageFrom } from "../utils/formErrors";
import React,{useState, useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {Box, CircularProgress} from '@mui/material';
import ActiveBar from './PolicyNavbarUpdated';
import BtnPrimary from './PrimaryButton';
import FormField from './Formfield';
import TypeBtn from './AddRemoveButton';
import SuccessDialog from './SuccessDialog';
import ErrorMsg from './ErrorMsg';
import {updatePolicy} from "../services/policy";
import { useOrgEmployees } from '../services/useOrgData';
import { useNotify } from './NotificationProvider';
import { getPolicyById } from '../services/expense';

import { tokens } from "../theme";
// reviewLink (optional): when provided, after saving approvers navigate there
// (the expense Review step) instead of finishing with the success dialog.
const PolicyRules = ({addNewLink, viewAllLink, reviewLink}) => {
  const notify = useNotify();
  const navigate = useNavigate();
  const { data: employees } = useOrgEmployees();
  const [loading,setLoading] = useState(false);
  const [apiCall,setApiCall] = useState(false);
  const [policyId,setPolicyId] = useState("");
  const [approver, setApprover] = useState([""]);
  /**
   * Field-level, and only field-level. "Choose an approver" is a fact about the
   * control and belongs under it; a failed write is not the reader's mistake and
   * goes to a toast instead. They shared one slot before, which made a server
   * failure look like a field somebody had filled in wrongly.
   */
  const [approverError, setApproverError] = useState("");
  const checkApprovers = (list) =>
    (list || []).filter((a) => a).length === 0 ? "Choose at least one approver." : "";
  const {state} = useLocation();
  const [isSuccessDialogOpen,setIsSuccessDialogOpen] = useState(false);
  const approverOptions = (employees || []).map(employee => ({
    name: employee.fname+" "+employee.lname,
    value: employee._id
  }));

  useEffect(() => {
    if (state) {
      setPolicyId(state.policyId);
      fetchPolicyData(state.policyId); 
    } 
  }, [state]);

  const fetchPolicyData = async (policyId) => {
    setLoading(true);
    try {
        const res = await getPolicyById(policyId);
        setApprover(res?.data?.approverIds || [""]);
    }catch (error) {
        notify.error(error?.message || "Failed to load policy data");
    } finally {
        setLoading(false);
    }
  };

  const handleAddApproval = () =>{
    setApprover([...approver,""])
  }

  const handleRemoveApprover = (index) => {
    let approverList = [...approver];
    approverList.splice(index, 1);
    setApprover(approverList);
  };

  const handleApproverChange = (index, value) => {
    const updatedApprover = [...approver];
    updatedApprover[index] = value;
    setApprover(updatedApprover);
  };

  const handleNextClick = async() => {
    setApiCall(true);
    try{
      const res = await updatePolicy(policyId,{approverIds:approver});
      if(res.success){
        if (reviewLink) navigate(reviewLink, { state: { policyId } });
        else setIsSuccessDialogOpen(true);
      }else{
        setApproverError("Choose at least one approver.");
        notify.error(errorMessageFrom(res, "Could not save approvers"));
      }
    }catch(error){
      notify.error(error?.message || "Something went wrong saving approvers");
    } finally {
      setApiCall(false);
    }
};

  return (
    loading?(
      <Box sx={{width:"100%", height:"100%",display:"flex", justifyContent:"center"}}>
        <CircularProgress/>
      </Box>
    ):(
    <Box sx={{width:"100%", height:"100%"}}>
        <Box sx={{display:"flex", justifyContent:"space-between"}}>
              <ActiveBar active={["Policy Details","Add Category","Assign Policy","Rules"]} value="80"/>
        </Box>
        <Box sx={{marginTop: "2rem", paddingBlock: "1rem"}}>
            <Box sx={{fontWeight:"500", fontSize: "1rem",lineHeight: 1.7, color:tokens.textMuted,marginBottom: "2rem"}}>
              Approval Chain
            </Box>
            <Box>
            {
                approver?.map((item,index)=>(
                  <Box key={index} 
                       sx={{ width: "100%", 
                             display: "flex",  
                             marginBottom: "1rem", 
                             justifyContent:"space-between",
                             padding: "1.25rem 2rem",
                             borderRadius:"10px",
                             border:`1px solid ${tokens.border}`
                          }}
                  >
                        <FormField
                            label="Employee Name"
                            type="select"
                            options={approverOptions}
                            value={item}
                            onChange={(e) => { handleApproverChange(index, e.target.value); setApproverError(""); }}
                      onBlur={() => setApproverError(checkApprovers(approver))}
                        />
                        <TypeBtn type="remove" onClick={()=>handleRemoveApprover(index)}>
                                Remove 
                        </TypeBtn>
                  </Box>
                ))
            }
            <TypeBtn onClick={handleAddApproval} type="add">
                Add Approver
            </TypeBtn>
            <ErrorMsg>{approverError}</ErrorMsg>
          </Box>
        </Box>
        <Box sx={{display:"flex", justifyContent:"end", marginTop: "2rem"}}> 
            <BtnPrimary 
            onClick={handleNextClick} 
            sx={{width:"10rem", height:"3.125rem", borderRadius:"10px"}}
            disabled={apiCall}
            >
            {apiCall?<CircularProgress/>:(reviewLink?"Review":"Save Policy")}
            </BtnPrimary>
        </Box>
        <SuccessDialog 
              open={isSuccessDialogOpen} 
              onClose={()=>setIsSuccessDialogOpen(false)} 
              message={`Policy created successfully!`} 
              addNewLink={addNewLink} 
              addNewText="Create New Policy" 
              viewAllLink={viewAllLink} 
              viewAllText="View All Policies"
        />
    </Box>
  ))
}

export default PolicyRules